export const LeadConvertSizeSqftToSqmRuleSlider = (value, onValueChanged) => {
    let  sm = [];
    if (value && value[0] && value[1]) {
        sm[0] = (parseFloat(value[0]) * 0.092903);
        sm[1] = (parseFloat(value[1]) * 0.092903);

        if(sm[0])
        sm[0] = sm[0] ? parseFloat(sm[0].toFixed(2)) :  0 ; 
        if(sm[1])
        sm[1] = sm[1] ? parseFloat(sm[1].toFixed(2)) :  0 ; 
    }
    onValueChanged(sm, 0, 'size_sqm');
};

export const LeadConvertSizeSqmToSqftRuleSlider = (value, onValueChanged) => {
    let  sqftValues = [];
    if (value && value[0] && value[1]) {
        sqftValues[0] = (parseFloat(value[0]) * 10.76391042);
        sqftValues[1] = (parseFloat(value[1]) * 10.76391042);

        if (sqftValues[0])
          sqftValues[0] = sqftValues[0]
            ? parseInt(sqftValues[0].toFixed(2))
            : 0;

        if (sqftValues[1])
          sqftValues[1] = sqftValues[1]
            ? parseInt(sqftValues[1].toFixed(2))
            : 0; 
    }

    onValueChanged(sqftValues, 0, 'size_sqft');
};

export const LeadConvertSizeSqftToSqmRuleSlider1 = (value, setData, setRerender) => {
    let sm = [];
    if (value && value[0] && value[1]) {
        sm[0] = (value[0] * 0.092903);
        sm[1] = (value[1] * 0.092903);

       if (sm[0])
          sm[0] = sm[0]
            ? parseFloat(sm[0].toFixed(2))
            : 0;

        if (sm[1])
          sm[1] = sm[1]
            ? parseFloat(sm[1].toFixed(2))
            : 0; 

        
    }
    setData('size_sqm', sm);
    setRerender(Math.random());
};

export const LeadConvertSizeSqmToSqftRuleSlider1 = (value, setData, setRerender) => {
    let sqftValues = [];
    if (value && value[0] && value[1]) {
        sqftValues[0] = (value[0] * 10.76391042);
        sqftValues[1] = (value[1] * 10.76391042);

        if (sqftValues[0])
          sqftValues[0] = sqftValues[0]
            ? parseInt(sqftValues[0].toFixed(2))
            : 0;

        if (sqftValues[1])
          sqftValues[1] = sqftValues[1]
            ? parseInt(sqftValues[1].toFixed(2))
            : 0; 
    }
    setData('size_sqft', sqftValues);
    setRerender(Math.random());
};
